// Lists the columns a narrow datatable folds under each row, as Tabulator's own
// collapse formatter does, leaving out any whose cell is empty: a bare heading
// with nothing beside it reads as missing data
export function collapsedFields(data) {
  const shown = data.filter(
    ({ value }) => value instanceof Node || String(value ?? "").trim() !== "",
  );
  if (shown.length === 0) return "";

  const list = document.createElement("table");
  shown.forEach(({ title, value }) => {
    const row = list.insertRow();
    const heading = document.createElement("strong");
    heading.textContent = title;
    row.insertCell().appendChild(heading);
    const cell = row.insertCell();
    if (value instanceof Node) {
      cell.appendChild(value);
    } else {
      cell.innerHTML = value;
    }
  });
  return list;
}
